export type BgAddDisabledReason = 'keyMissing' | 'noSubmitterBgs'

export type SubmitterBgMembership = {
  bgMasterId: string
}

/**
 * 発電販売計画マスタの「BG 情報 + 追加」ボタン disable 判定 (F1 純関数)。
 *
 * 3938-occto-master-plan-spec-followup 設計書 §7。 電源ユニットマスタ 2a で
 * 「BG マスタの配下発電所が無い BG は追加できない」を外した (BG → 発電所の
 * 登録は発電販売計画マスタの発電所情報の行 1 か所になったため)。 追加できない
 * のは、計画提出者の所属 BG が無い時だけ。
 *
 * 設計書は `submitters[].members[].bgMasterId` (= 集約 RPC
 * `GetGenerationSalesPlanMasterFormOptionsResponse.submitters` の要素)
 * から判定する signature を提案しているが、実際の
 * `SubmitterMasterListItem` (bffuser/v1/occto_master_model_pb.ts) には
 * `members` field が存在しない (`members` は `SubmitterMaster` full
 * entity — `GetSubmitterMaster` RPC の応答 — にのみ存在する)。
 * そのため呼び出し側 (Create/Edit モーダル) が選択中の submitterMasterId
 * について `useGetSubmitterMaster` で個別取得した `members` を直接渡す
 * signature に変更している (完了報告の意図的逸脱を参照)。
 *
 * @param submitterCode 選択中の計画提出者コード (未選択なら 'keyMissing')
 * @param members 選択中提出者の所属 BG membership。 未取得 (loading / fetch
 *   失敗) を表す `undefined` と、 取得済みかつ登録なしを表す空配列は明確に区別
 *   する: `undefined` の場合は `undefined` を返し (呼び出し側で「+ 追加」
 *   button の disable も note 表示もしない = 誤った「所属 BG が未登録です」
 *   を出さない)、 空配列の場合のみ `'noSubmitterBgs'` を返す。
 */
export function deriveBgAddDisabledReason(
  submitterCode: string | undefined,
  members: SubmitterBgMembership[] | undefined,
): BgAddDisabledReason | undefined {
  if (submitterCode === undefined || submitterCode === '') return 'keyMissing'
  if (members === undefined) return undefined
  if (members.length === 0) return 'noSubmitterBgs'
  return undefined
}
